import React from 'react';
import { cn } from '@newcore/ui/cn';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Skeleton } from '@newcore/ui/skeleton';
import { textVariants } from '@newcore/ui/variants/typography-text-variants';

// Matches ApplicationTile's settled size so resolving the catalog cannot jump.
export const ApplicationTileSkeleton: React.FC = () => (
  <div className='flex w-16 shrink-0 flex-col items-center gap-1.5'>
    <Skeleton className='size-16 rounded-2xl' />
    <Skeleton
      className={cn(
        textVariants({ size: TextSizes.XS }),
        'h-[1em] w-19.5 rounded-full'
      )}
    />
  </div>
);
